import UOaccounts from './views/uo-accounts.c';
export default UOaccounts;
